import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=a80f5c58&scoped=true&"
import script from "./Library.vue?vue&type=script&lang=ts&"
export * from "./Library.vue?vue&type=script&lang=ts&"
import style0 from "./Library.vue?vue&type=style&index=0&id=a80f5c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80f5c58",
  null
  
)

export default component.exports